module.exports = "/work-site/img/enter_car.1588bc3e.png";